module.exports = __webpack_public_path__ + "img/tpd_blue.bb136d0a.png";